<template>
  <div class="merchant-container">
    <div class="side-nav">
      <MerchantSideNav />
      <MenuToggle />
    </div>
    <div class="merchant-body transaction-body">
      <header>
        <MerchantHeader />
      </header>
      <div class="dashboard-content">
        <div class="row align-items-center mt-5">
          <h3>Settings</h3>
          <span class="material-icons mx-3"> arrow_forward_ios </span>
          <h3>Keys</h3>
          <span class="env-badge ml-3" :class="isSandbox ? 'is-sandbox' : 'is-live'">
            {{ isSandbox ? 'Sandbox' : 'Live' }}
          </span>
        </div>
        <div class="row" v-if="!activeKey">
          <div class="col-12 pl-0">
            <div class="card-style">
              <p class="mb-0">
                No {{ isSandbox ? 'sandbox' : 'live' }} API key is available for this account.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 pl-0">
            <div class="card-style">
              <h3>Public Key</h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nam,
                sint aliquam dicta assumenda cumque nulla consectetur dolores
                harum error nostrum odio inventore beatae, doloremque provident
                quaerat doloribus in id dolorum.
              </p>
              <div class="row justify-content-center align-items-center">
                <div class="mb-3 col-12 col-lg-6 position-relative">
                  <b-form-input type="text" placeholder="" id="public_key" :value="activeKey ? activeKey.public_key : ''" readonly> </b-form-input>
                  <span class="position-absolute">Your Public key </span>
                  <span style="font-size: 14px; color: #0da90d; font-weight: 600;" v-if="public_key_copied">Public Key Copied.</span>
                </div>
                <div class="col-12 col-lg-2">
                  <p @click="copyPublicKey">
                    <span class="material-icons"> content_copy </span>
                    <span>Copy</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 pl-0">
            <div class="card-style">
              <h3>Private Key</h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nam,
                sint aliquam dicta assumenda cumque nulla consectetur dolores
                harum error nostrum odio inventore beatae, doloremque provident
                quaerat doloribus in id dolorum.
              </p>

              <div class="row justify-content-center align-items-center">
                <div class="mb-3 col-12 col-lg-6 position-relative">
                  <b-form-input type="text" placeholder="" id="private_key" :value="activeKey ? activeKey.secret_key : ''" readonly> </b-form-input>
                  <span class="position-absolute">Your Private key </span>
                  <span style="font-size: 14px; color: #0da90d; font-weight: 600;" v-if="private_key_copied">Private Key Copied.</span>
                </div>
                <div class="col-12 col-lg-2">
                  <p @click="copyPrivateKey">
                    <span class="material-icons"> content_copy </span>
                    <span>Copy</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <MerchantFooter />
    </footer>
  </div>
</template>
<script>
import MerchantHeader from "./MerchantHeader.vue";
import MerchantFooter from "./MerchantFooter.vue";
import MerchantSideNav from "./MerchantSideNav.vue";
import MenuToggle from "./MenuToggle.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    MerchantHeader,
    MerchantFooter,
    MerchantSideNav,
    MenuToggle,
  },
  data() {
    return {
      public_key_copied: false,
      private_key_copied: false,
    }
  },
  computed: {
    ...mapState([
      "successmessage",
      "errormessage",
      "message",
      "merchant_key",
      "merchantEnvironment",
    ]),
    isSandbox: function () {
      return this.merchantEnvironment === "sandbox";
    },
    /**
     * GET merchant/keys returns one entry per environment.
     * Pick the one matching the header switch instead of always taking [0]
     * (which was the live key, so sandbox was never reachable).
     */
    activeKey: function () {
      const list = Array.isArray(this.merchant_key) ? this.merchant_key : [];
      const env = this.merchantEnvironment;
      const match = list.filter(function (k) {
        return k && k.environment === env && k.is_active !== false && !k.revoked_at;
      });
      if (match.length) { return match[0]; }
      // fall back to any key for that environment, even if inactive
      const any = list.filter(function (k) { return k && k.environment === env; });
      return any.length ? any[0] : null;
    },
  },
  created() {
    this.getMerchantKeys();
  },
  mounted(){
    //
  },
  methods: {
    ...mapActions([
      "getMerchantKeys"
    ]),
    copyPublicKey() {
      let publicKeyValue = document.getElementById("public_key");
      publicKeyValue.select();
      document.execCommand('copy');

      this.public_key_copied = true;
      setTimeout(() => {
        this.public_key_copied = false;
      }, 2000);
    },
    copyPrivateKey() {
      let privateKeyValue = document.getElementById("private_key");
      privateKeyValue.select();
      document.execCommand('copy');

      this.private_key_copied = true;
      setTimeout(() => {
        this.private_key_copied = false;
      }, 2000);
    },
  },
};
</script>
<style lang="scss" scoped>
.env-badge {
  font-size: 12px;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.env-badge.is-live { background: #e6f0f8; color: #0066b3; }
.env-badge.is-sandbox { background: #fdf3e0; color: #e08b00; }

</style>